import React, { useState, useRef, useEffect } from "react";
import { Form, InputGroup, ListGroup } from "react-bootstrap";
import { Button, Container } from 'react-bootstrap'
import Search from "../assets/images/search-icon.svg";
import Location from "../assets/images/location-icon.svg"
import { GET_SUBURB_LIST } from "../api/constants";
import { useNavigate } from "react-router-dom";
import useSuburbs from "../hooks/useSuburbs";


function HomeBanner() {
  const navigate = useNavigate();
  const inputGroupRef = useRef(null);
  const [inputHeight, setInputHeight] = useState(0);
  const [query, setQuery] = useState("");
  const [filtered, setFiltered] = useState([]);
  const { suburbs, loading, error } = useSuburbs();

 

  useEffect(() => {
    if (inputGroupRef.current) {
      const height = inputGroupRef.current.offsetHeight;
      setInputHeight(height);
    }
  }, []);
  useEffect(() => {
    const handleResize = () => {
      if (inputGroupRef.current) {
        setInputHeight(inputGroupRef.current.offsetHeight);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const handleChange = (e) => {
    const value = e.target.value;
    setQuery(value);

    if (value.length > 0) {
      const results = suburbs.filter((item) =>
        item.toLowerCase().includes(value.toLowerCase())
      );
      setFiltered(results);
    } else {
      setFiltered([]);
    }
  };

  const handleSelect = (item) => {
    setQuery(item);
    setFiltered([]);
  };

 const handleSubmit = async (e) => {
  e.preventDefault();
  if (!query) return;

  // Extract only the suburb name (before the first comma)
  const suburbName = query.split(",")[0].trim();

  try {
    navigate("/search?suburb=" + encodeURIComponent(suburbName));
  } catch (err) {
    console.error("Search error:", err);
  }
};


  return (
    <>
      <div className="home-banner">
        <Container>
          <h1>Find the right home<br /> at the right price</h1>
          <Form onSubmit={handleSubmit}>
            <InputGroup ref={inputGroupRef}>
              <Form.Control
                type="search"
                placeholder="Enter a suburb or city"
                value={query}
                onChange={handleChange}
              />
              <Button type="submit">
                <img src={Search} alt="" />
              </Button>

            </InputGroup>
            {filtered.length > 0 && (
              <ListGroup style={{ top: inputHeight + 4, }}>
                {filtered.map((item, index) => (
                  <ListGroup.Item
                    key={index}
                    action
                    onClick={() => handleSelect(item)}
                  >
                    <img src={Location} alt="" /> {item}
                  </ListGroup.Item>
                ))}
              </ListGroup>
            )}
          </Form>
        </Container>
      </div>
    </>
  )
}
export default HomeBanner